import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';
import { queryKeys } from '@/lib/queryKeys';

/** 서버 상한({@code PersonnelService.DUTIES_MAX_LENGTH})과 같은 값. */
export const DUTIES_MAX_LENGTH = 2000;

export type MyDuties = { duties: string | null };

/**
 * 내 담당업무 (V437). 웹 마이페이지와 앱이 같은 훅을 쓴다 — 이 파일은 앱(Metro)도 그대로 import 한다.
 *
 * <p>고치면 <b>바로 반영된다</b>(사용자 결정 2026-10-08). 인사자료의 같은 칸과 한 칸이다.
 */
export function useMyDuties() {
  return useQuery({
    queryKey: queryKeys.myDuties,
    queryFn: () => apiFetch<MyDuties>('/v1/home/profile/duties'),
  });
}

export function useSaveMyDuties(onSaved?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (duties: string) => apiFetch<MyDuties>('/v1/home/profile/duties', { method: 'PUT', body: { duties } }),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.myDuties, saved);
      // 직원찾기에 남은 내 명함·트리(검색이 읽는 글)도 옛 글이다.
      void queryClient.invalidateQueries({ queryKey: queryKeys.directoryPerson });
      void queryClient.invalidateQueries({ queryKey: queryKeys.directoryTree });
      onSaved?.();
    },
  });
}
